import React, { useContext, useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import TabMenu from "~/common/components/TabMenu";
import { Case, If } from "~/common/components/If";

// Pages
import RoundManageAll from "~/pages/round/RoundManage/List/list";
import { useNavigate } from "react-router-dom";
import { AppManContext } from "../RoundManContext";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import pageMaker from "~/common/constants/pageMaker";
import EvaluatePage from "~/pages/round/RoundList/evaluate";
import translation from "~/i18n";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";

const RoundManContainer = () => {
	const [
		{
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	const { t } = useTranslation();
	const navigate = useNavigate();
	const { currentTab, setCurrentTab } = useContext(AppManContext);
	const [pageType, setPageType] = useState("list");
	const [evalFormData, setEvalFormData] = useState({ roundIdx: 0, name: "", page: 1, size: 10 });
	const [totalNum, setTotalNum] = useState(0);
	const [evalListData, setEvalListData] = useState({});
	const viewEvalRequest = useRequest("post", "vc/round/review/list");
	const pageInfo = pageMaker(evalFormData.page, evalFormData.size, totalNum);

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				if (currentPath.auth !== "edit") {
					showAuthAlert();
					return;
				}
				navigate("/round/register");
			}}
		>
			{t("pages.round.RoundManage.container.button01")}
		</button>,
	];
	const headerButtonsEval = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				setPageType("list");
			}}
		>
			{t("pages.round.RoundManage.container.button02")}
		</button>,
	];

	const tabMenuList = [
		{
			id: "전체",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title01"),
		},
		{
			id: "오픈대기",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title02"),
		},
		{
			id: "진행중",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title03"),
		},
		{
			id: "지원마감",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title04"),
		},
		{
			id: "심사중",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title05"),
		},
		{ id: "종료", title: translation.t("pages.round.RoundManage.List.status04") },
	];

	useEffect(() => {
		switch (viewEvalRequest.state) {
			case API_STATE.done:
				const requestEvaluateView = viewEvalRequest.response?.data;
				setTotalNum(requestEvaluateView.total);
				setEvalListData(requestEvaluateView);
				setPageType("eval");
				break;
			default:
				break;
		}
	}, [viewEvalRequest.state, viewEvalRequest.response, evalListData]);

	useEffect(() => {
		if (evalFormData.roundIdx !== 0) {
			viewEvalRequest.call(evalFormData);
		}
	}, [evalFormData]);

	const viewEvalPage = (idx) => {
		navigate(`/round/list/evaluate/${idx}`);
	};

	return (
		<NavbarAndSidebarLayout
			menu={["round", "management"]}
			type={"main"}
			buttonList={pageType === "eval" && headerButtonsEval}
			menuName={pageType === "list" ? "round-management" : "round-eval"}
		>
			<PageHeader buttonList={pageType === "list" && headerButtons} />
			<If condition={pageType}>
				<Case condition={"list"}>
					<TabMenu
						tabItem={tabMenuList}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
					<RoundManageAll
						viewEvalPage={viewEvalPage}
						currentTab={currentTab}
						currentPath={currentPath}
						showAuthAlert={showAuthAlert}
					/>
				</Case>
				<Case condition={"eval"}>
					<EvaluatePage
						pageInfo={pageInfo}
						evalListData={evalListData}
						viewtype={false}
						setEvalFormData={setEvalFormData}
						evalFormData={evalFormData}
					/>
				</Case>
			</If>
			<>
				<AuthAlert
					message={
						<>
							권한이 없습니다. <br />
							관리자에게 문의하세요.
						</>
					}
					type="warning"
					confirm="확인"
				/>
			</>
		</NavbarAndSidebarLayout>
	);
};

export default RoundManContainer;
